import { Spinner } from '@heroui/react';

import { AutoAuth } from '@/components/login/AutoAuth';
import { useGetPatientQuery } from '@/patient-app-common/api/patientApi';
import { useAppSelector } from '@/redux/hooks';

import type { ReactNode } from 'react';

export function DirectProtectedComponent({
  component,
}: {
  component: ReactNode;
}) {
  const { token, mfaChecked, patientId } = useAppSelector(({ auth }) => auth);

  // Fetch patient data to ensure the user is authenticated.
  const { isLoading: isLoadingPatient, isFetching: isFetchingPatient } =
    useGetPatientQuery(undefined, { skip: !token });

  const authenticated = !!(token && mfaChecked && patientId);

  if (authenticated) {
    return component;
  }

  if (token && (isLoadingPatient || isFetchingPatient)) {
    return (
      <div className="flex flex-row h-[100dvh] justify-center">
        <div className="flex flex-col justify-center">
          <Spinner className="m-4" color="primary" size="lg" />
        </div>
      </div>
    );
  }

  return <AutoAuth />;
}
